import Skeleton from "../../common/Skeleton";

/**
 * Mirrors the real metric strip: four segments split by hairline rules, the
 * first a little wider for the two index figures.
 */
const STAT_PLACEHOLDERS = [
  { key: "index", grow: true },
  // Temporarily hidden with the Abillion Performance metric.
  // { key: "abillion", grow: false },
  { key: "stocks", grow: false },
  { key: "peak", grow: false },
  { key: "current", grow: false },
];

const PerformanceStatsSkeleton = () => {
  return (
    <div
      className="flex flex-wrap items-stretch divide-x divide-[#d0d4e4] overflow-hidden bg-white dark:divide-[#394564] dark:bg-[#121419]"
      aria-hidden
    >
      {STAT_PLACEHOLDERS.map(({ key, grow }) => (
        <div
          key={key}
          className={`flex min-w-0 items-center gap-2 px-2 py-1.5 ${
            grow ? "flex-[1.4]" : "flex-1"
          }`}
        >
          <Skeleton className="h-6 w-6 flex-shrink-0 rounded-md" />
          <div className="flex min-w-0 flex-1 flex-col justify-center gap-1">
            <Skeleton className="h-2 w-20 max-w-full rounded" />
            <Skeleton className="h-4 w-14 rounded" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default PerformanceStatsSkeleton;
